module.exports = __webpack_public_path__ + "static/GrayGminaPuck-72464cf5b8513373c19f016904ac58c8.svg";